import { render, staticRenderFns } from "./SettingsStageTitle.vue?vue&type=template&id=0b688af6&"
import script from "./SettingsStageTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsStageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports